import React, { useState } from 'react';
import './Login.css';
import { Link, useHistory } from 'react-router-dom'
import { auth } from './firebase.js'



function Login(){

const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
//allows us to change the url/redirect based on our history.
const history = useHistory();

const signIn = e => {
    e.preventDefault()

    auth
        .signInWithEmailAndPassword(email, password)
        //'auth' is returnedS onSuccess:
        .then(auth => {
            history.push('/');
        })
        .catch(
            error => alert(error.message)
        )
}

const register = e => {
    e.preventDefault()

    auth
        .createUserWithEmailAndPassword(email, password)
        .then((auth) => {
            //.then() is called after a successful .createUserWit.....(). We log to see it.
            console.log(auth)

            //if successful, redirect to home.
            if(auth){
                history.push('/')
            }
        })
        .catch(
            error => alert(error.message)
        )
}


    return(
        <div className="login">
            <Link to="/">
            <img 
            className="login__logo"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png"
            />
            </Link>
            <div className="login__container">
                <h1>Sign-in</h1>
                <form>
                    <h5>E-mail</h5>
                    <input  
                        type="text"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />

                    <h5>Password</h5>
                    <input                  type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value )}
                    />
                    <br />
                    <button className="login__signInButton"
                    onClick={signIn}>Sign In</button>
                </form>
                <p>
                    By signing-in you agree to the AMAZON FAKE CLONE Conditions of Use & Sale. Please see our Privacy Notice, our Cookies Notice and our Interest-Based Ads
                    Notice.
                </p>

                <button className="login__registerButton"
                onClick={register}>Create your Amazon account</button>

            </div>
        </div>
        
    )
}

export default Login;